function timeNowMsWithOffset(offsetMin) {
    const offsetMs = (offsetMin ?? 0) * 60 * 1000;
    const date = new Date();
    date.setTime(date.getTime() + offsetMs);
    return date;
}
export function createIntervalOffset(offsetMin) {
    const start = timeNowMsWithOffset(offsetMin < 0 ? offsetMin : 0);
    const end = timeNowMsWithOffset(offsetMin > 0 ? offsetMin : 0);
    return {
        from: start.toJSON(),
        to: end.toJSON(),
    };
}
export function createIntervalOffsetV2(offsetMin) {
    const start = timeNowMsWithOffset(offsetMin < 0 ? offsetMin : 0);
    const end = timeNowMsWithOffset(offsetMin > 0 ? offsetMin : 0);
    return {
        gte: start,
        lt: end,
    };
}
export function toInterval(from, to) {
    return {
        from: from.toJSON(),
        to: to.toJSON(),
    };
}
export function toIntervalV2(from, to) {
    return {
        gte: from,
        lt: to,
    };
}
export function getErrorAsString(error) {
    if (typeof error === "object" && error !== null && "message" in error) {
        return String(error.message);
    }
    else {
        return String(error);
    }
}
//# sourceMappingURL=util.js.map